<template style="width: 100%;height:100%;">
    <label class="location_menu">
        <img style="margin-right:10px; filter: invert(31%) sepia(69%) saturate(3992%) hue-rotate(177deg) brightness(103%) contrast(102%);" src="@/assets/IMGS/SVG/location.svg" alt="location">
        <span v-on:click.stop="eRegionToggle()" class="lmenu_text" v-bind:style="{ color: regionLabelColor }">{{ currentRegion }}</span>
    </label>
        <div id='modalRegion' v-if="modalVisible && isMobile == false" class="container-modalRegion" v-on:click.stop>
            <span class="modal-window" style="min-width: 800px;max-width:800px !important; min-height: 400px;" v-bind:class="{ 'modal-window-left': isLeft }"
              ref="my-modal" hide-footer title="Using Component Methods">
                <div class="window-header" style="height: 45px;">
                    <h3 style="padding-left: 20px;">Выберите регион</h3>
                    <img v-on:click="eRegionToggle()" class="modal-cancel" src="../assets/IMGS/SVG/cancel.svg" alt="cancel" style="padding-right: 20px; width:16px;height: 16px;">
                </div>
                <div class="container-ModalBlock" style="height: 100%;">
                    <span class="ModalBlock">
                        <!--<label class="modal-header" style="width: 0px; font-weight: 900; padding-left: 25px;"></label>-->
                        <div class="modalReg-container">
                            <div class="modal-region" v-for="country in eCountry" :key="country">
                                <span v-on:click.stop="seteCountry(country.country )"  v-bind:class="{ 'selected-country-span' : country.country == currentCountry }">{{ country.country }}</span>
                                <img v-if="country.country == currentCountry" id="m-arrow" v-on:click.stop="eRegionToggle()" class="modal-arrow" src="../assets/IMGS/SVG/arrowMenu.svg" alt="arrowmenu">
                                <p class="line_paragrahp"></p>
                            </div>
                        </div>
                    </span>
                    <span class="ModalBlock">
                        <!--<label class="modal-header" style="width: 0px; font-weight: 900; padding-left: 25px;"></label>-->
                        <input style="margin-top: 10px; height: 25px; margin-left: 5px; width: 90%; border-radius: 0px; border: 1px solid #e2e5e5;" type="text" id="regionSearch" name="regionSearch" placeholder="Поиск" class="forminput" v-model="regionSearch">
                        <div class="modalReg-container" style="width:490px; overflow-y:scroll; max-height: 235px; display: block;">
                            <div class="modal-region" v-for="(region, index) in filteredRegions" :key="index">
                                <span v-on:click.stop="seteRegion(region.region)" v-bind:class="{ 'selected-region-span' : region.region == currentRegion }">{{ region.region }}</span>
                                <p class="line_paragrahp"></p>
                            </div>
                        </div>
                    </span>
                </div>
                <div class="modal-do">
                </div>
            </span>
            <div style="display: none" v-on:click="eRegionToggle()" class="eRegionToggleHelper"></div>
        </div>

        <div id='modalRegion' v-if="modalVisible && isMobile == true" class="container-modalRegion" v-on:click.stop>
            <span class="modal-window" style="min-width: 300px; max-width:350px !important; min-height: 430px;" v-bind:class="{ 'modal-window-left': isLeft }"
              ref="my-modal" hide-footer title="Using Component Methods">
                <div class="window-header" style="height: 45px;">
                    <h3 style="padding-left: 20px;">Выберите регион</h3>
                    <img v-on:click="eRegionToggle()" class="modal-cancel" src="../assets/IMGS/SVG/cancel.svg" alt="cancel" style="padding-right: 20px; width:16px;height: 16px;">
                </div>
                <div class="container-ModalBlock" style="width: 100%; height: 100%;">
                    <span class="ModalBlock">
                        <!--<label class="modal-header" style="width: 0px; font-weight: 900; padding-left: 25px;"></label>-->
                        <div class="modalReg-container">
                            <div class="modal-region" v-for="country in eCountry" :key="country">
                                <span style="font-size: 20px !important;" v-on:click.stop="seteCountry(country.country )"  v-bind:class="{ 'selected-country-span' : country.country == currentCountry }">{{ country.country }}</span>
                                <!--<img v-if="country.country == currentCountry" id="m-arrow" v-on:click.stop="eRegionToggle()" class="modal-arrow" src="../assets/IMGS/SVG/arrowMenu.svg" alt="arrowmenu">-->
                                <p class="line_paragrahp"></p>
                            </div>
                        </div>
                    </span>
                    <span class="ModalBlock">
                        <!--<label class="modal-header" style="width: 0px; font-weight: 900; padding-left: 25px;"></label>-->
                        <input style="margin-top: 25px; height: 25px !important; margin-left: 5px; width:85%; border-radius: 0px; border: 1px solid #e2e5e5;" type="text" id="regionSearch" name="regionSearch" placeholder="Выберите регион" class="forminput" v-model="regionSearch">
                        <div class="modalReg-container" style="overflow-y:scroll; max-height: 235px; display: block;">
                            <div class="modal-region" v-for="(region, index) in filteredRegions" :key="index">
                                <span v-on:click.stop="seteRegion(region.region)" v-bind:class="{ 'selected-region-span' : region.region == currentRegion }">{{ region.region }}</span>
                                <p class="line_paragrahp"></p>
                            </div>
                        </div>
                    </span>
                </div>
                <div class="modal-do">
                </div>
            </span>
            <div style="display: none" v-on:click="eRegionToggle()" class="eRegionToggleHelper"></div>
        </div>
</template>
  
<script>
    import $ from 'jquery';
    import regionsData from "../data/regions.json";

    export default {
        props: {
            defaultRegion: {
                default: ""
            },
            isCached: {
                default: false
            },
            getApi: {
                default: true
            },
            isLeft: {
                default: false
            },
            regionLabelColor: {
                default: "'#00A3FF'"
            }
        },
        name: 'eRegionMenu',
        el: 'modalRegion',
        created() {
            this.isMobile = this.getMobileScreen()
        },
        mounted() {
            this.isMobile = this.getMobileScreen()
            if (this.defaultRegion != "") this.currentRegion = this.defaultRegion;
            var current_region = localStorage.currentRegion;
            if (current_region && current_region != "null" && this.isCached) {
                this.currentRegion = current_region;
            } else {
                if (this.getApi) this.getUserRegion()
            }
        },
        data() {
            let eRegionsDict = {}
            for (let enName in regionsData) {
                let curCountry = regionsData[enName]["country"];
                let curRegionRu = regionsData[enName]["ru"];
                if (!eRegionsDict[curCountry]) eRegionsDict[curCountry] = []
                eRegionsDict[curCountry].push({ region: curRegionRu })
            }
            let eCountryList = []
            for (let countryName in eRegionsDict) {
                eCountryList.push({ country: countryName })
            }
            return {
                isMobile: false,
                regionSearch: '',
                eCountry : eCountryList,
                currentCountry : 'Россия',
                eRegions: eRegionsDict,
                currentRegion : 'Выберите местоположение',
                modalVisible: false,
            }
        },
        computed: {
            filteredRegions() {
                const searchTerm = this.regionSearch.toLowerCase();
                return this.eRegions[this.currentCountry].filter(region => region.region.toLowerCase().includes(searchTerm));
            },
        },
        methods: {
            getMobileScreen() {
                if (screen.width <= 1024) {
                    return true
                } else {
                    return false
                }
            },
            eRegionToggle() {
                this.modalVisible = !this.modalVisible;
                if (this.modalVisible === true ) {
                    $("#m-arrow").css("transform", 'rotate(-90deg)');
                } else {
                    $("#m-arrow").css("transform", 'rotate(180deg)');
                }
            },
            seteRegion(region, dontToggle) {
                this.currentRegion = region;
                if (!dontToggle) this.eRegionToggle();
                if (this.isCached) {
                    localStorage.currentRegion = region;
                }
            },
            seteCountry(country) {
                this.currentCountry = country;
                if (this.isCached) {
                    localStorage.currentCountry = country;
                }
            },
            getUserRegion() {
                var self = this;
                function callback(ev) {
                    console.log('WHAT IS IT ???')
                    console.log(ev)
                }
                callback(0)
                $.ajax({
                    url: "https://geolocation-db.com/jsonp",
                    jsonpCallback: 'callback',
                    dataType: "jsonp",
                    success: function(location) {
                        var getRuState = regionsData[location.state]["ru"]
                        self.seteRegion(getRuState, true)
                        /* LEGACY - not improved, when uncommented will break
                        var urlGeoCoding = 'https://geocode-maps.yandex.ru/1.x/?format=json&apikey=8f6c53cc-ef27-4044-84cd-1de9c0c07871&geocode=' + location.longitude + ',' + location.latitude
                        $.ajax({
                            url: urlGeoCoding,
                            jsonpCallback: "callback",
                            dataType: "jsonp",
                            success: function(result) {
                                console.log(result.response.GeoObjectCollection.featureMember[3].GeoObject.name)
                                self.seteRegion(result.response.GeoObjectCollection.featureMember[3].GeoObject.name);
                            },
                        }).done(function (  ) {});*/
                    }
                })
            }
        }
    }
</script>

<style lang="css" scoped src="@/assets/css/eRegion.css"></style>
<style lang="css" scoped src="@/assets/css/modal.css"></style>
